import React, { Component } from 'react';
import { serverIp, firebaseAuth, toCurrency, pythonApiIp, logComponentLoad } from '../../../../config/constants.js'
import { Divider } from 'semantic-ui-react';
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios';
import { SingleDatePicker } from 'react-dates';
//import { getPrintValues, getDesigners, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { checkAdminEmail, getPrintValues, } from '../algoliaDashboard/AlgoliaMiscUtils';
import Select from 'react-select';

class ViewRequisitionsDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dropdownItems: [],
        }
    }

    componentDidMount() {
        console.log("entx8 +++++ componentDidMount - ");

        this.getRequisitions();
    }


    // ##########################::  submitRequisition :##########################:
    getRequisitions = () => {
        console.log("entx1 +++++ getRequisitions - ");
        axios.post(serverIp + 'billing/fetchRequisitions', {
            apiKey: "fetchRequisitions",
            enteredBy: this.props.user.email,
            action: this.props.type
        })
            .then((response) => {
                console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                console.log("entx22 result:" + response.data.result);

                // CHECK RECEIPTS
                if (response.data.result && response.data.dropdownItems) {

                    this.setState({
                        loading: false,
                        dropdownItems: response.data.dropdownItems
                    });
                    // alert("password retrieved:");

                    // CHECK ORDER NUMBER
                } else if (!response.data.result) {
                    alert("Error:" + response.data.message);
                    this.setState({ loading: false });
                }

            })
            .catch((error) => {
                console.log(error);
            });
    }



    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }


    render() {

        const reqsDropdown = this.state.dropdownItems.length > 0
            ? <div>
                <Divider horizontal>{this.props.title}</Divider>
                <Select
                    name="form-field-name"
                    value={this.props.unpaid_req}
                    options={this.state.dropdownItems}
                    onChange={this.props.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />
            </div>
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <h4>REQUISITIONS</h4>
                    {reqsDropdown}
                </div>
        );
    }
}

export default ViewRequisitionsDropdown;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Requisition/ViewRequisitionsDropdown.js